import { Link, useRouterState } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { Icon, type IconName } from "./Icon";

/**
 * SettingsShell — shared chrome for /settings/* pages.
 * Layout mirrors designs/Settings.html: 24px <h1>Settings</h1>
 * over a 194px sticky left-nav + content panel grid.
 *
 * The design uses <button class="set-nav">; this implementation
 * renders <Link> elements so routing stays declarative, and the
 * shared .set-nav styles in screens.css cover both elements.
 */
export function SettingsShell({ children }: { children: ReactNode }) {
  const router = useRouterState();
  const path = router.location.pathname;

  const sections: Array<{ to: string; label: string; icon: IconName }> = [
    { to: "/settings/account", label: "Account", icon: "user" },
    { to: "/settings/appearance", label: "Appearance", icon: "sun" },
    { to: "/settings/notifications", label: "Notifications", icon: "bell" },
    { to: "/settings/security", label: "Security", icon: "key" },
    { to: "/settings/connect", label: "AI tools", icon: "chat" },
    { to: "/settings/members", label: "Members", icon: "users" },
    { to: "/settings/workspace", label: "Workspace", icon: "grid" },
  ];

  return (
    <div className="pg-wrap">
      <h1>Settings</h1>
      <div className="set-grid">
        <nav aria-label="Settings categories" className="set-nav">
          {sections.map((s) => (
            <Link key={s.to} to={s.to} className={path === s.to ? "on" : ""}>
              <Icon name={s.icon} />
              {s.label}
            </Link>
          ))}
        </nav>
        <div className="set-content">{children}</div>
      </div>
    </div>
  );
}
